import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { SubmitRoboqlQueryRequest } from "@/shared/domain/query";

interface ConvertNlpToRoboqlOptions {
  orgId?: string;
  prompt: string;
}

export function useConvertNlpToRoboql() {
  const { queryService } = useDomainServices();

  // "Nope, we're not related, we get that a lot though" - queryClient
  const queryClient = useQueryClient();

  return useMutation<
    SubmitRoboqlQueryRequest,
    Error,
    ConvertNlpToRoboqlOptions
  >({
    mutationFn: async ({
      prompt,
      orgId,
    }: ConvertNlpToRoboqlOptions): Promise<SubmitRoboqlQueryRequest> => {
      return queryService.convertNlpToRoboql(prompt, {
        orgId: orgId,
      });
    },

    onSuccess: (roboqlRequest: SubmitRoboqlQueryRequest) => {
      queryClient.setQueryData(["roboqlRequest", prompt], roboqlRequest);
    },
  });
}
